import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const BackgroundElements = () => {
  return (
    <Container>
      <Circle1 
        animate={{
          y: [0, -20, 0],
          scale: [1, 1.1, 1],
          rotate: [0, 180, 360]
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      <Circle2 
        animate={{
          x: [0, 30, 0],
          y: [0, -20, 0],
          rotate: [360, 0, 360]
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      <Line1 
        animate={{
          rotate: [0, 360],
          scale: [1, 1.1, 1]
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      <Line2 
        animate={{
          rotate: [360, 0],
          scale: [1, 1.3, 1]
        }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      <Dots>
        {[...Array(5)].map((_, i) => (
          <Dot
            key={i}
            animate={{
              y: [0, -20, 0],
              opacity: [0.5, 1, 0.5]
            }}
            transition={{
              duration: 3,
              delay: i * 0.2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        ))}
      </Dots>
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
`;

const Circle1 = styled(motion.div)`
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  border: 2px solid rgba(38, 208, 206, 0.1);
  top: 15%;
  right: 10%;
  filter: blur(5px);
  will-change: transform, opacity;
`;

const Circle2 = styled(motion.div)`
  position: absolute;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  border: 2px solid rgba(26, 41, 128, 0.1);
  bottom: 20%;
  left: 15%;
  filter: blur(5px);
`;

const Line1 = styled(motion.div)`
  position: absolute;
  width: 400px;
  height: 400px;
  border: 1px solid rgba(38, 208, 206, 0.05);
  top: 40%;
  left: 30%;
  transform-origin: center;
  filter: blur(3px);
  will-change: transform, opacity;
`;

const Line2 = styled(motion.div)`
  position: absolute;
  width: 300px;
  height: 300px;
  border: 1px solid rgba(26, 41, 128, 0.05);
  bottom: 30%;
  right: 20%;
  transform-origin: center;
  filter: blur(3px);
`;

const Dots = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 20px;
`;

const Dot = styled(motion.div)`
  width: 10px;
  height: 10px;
  background: rgba(38, 208, 206, 0.2);
  border-radius: 50%;
  filter: blur(2px);
`;

export default React.memo(BackgroundElements); 